import { useCallback } from 'react';
import { ButtonProps } from './types';

export default function SplitButtonAlternativeAction({
  option,
  onClick,
}: {
  option: ButtonProps;
  onClick: (option: ButtonProps) => void;
}) {
  const onLocalClick = useCallback(() => {
    if (!option.disabled) {
      onClick(option);
    }
  }, [onClick, option]);
  return (
    <button
      id={option.id}
      className="SplitButton__alternativeAction"
      type="button"
      disabled={!!option.disabled}
      onClick={onLocalClick}
    >
      {option.text}
    </button>
  );
}
